module.exports = __webpack_public_path__ + "img/13frtr.4803f3a7.png";